export default __webpack_public_path__ + "static/Signature Class – Vertical 400x400-99762d1df97abcfc5e9e7a330dcc974c.svg";